/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  ButtonContainer,
  ScreenContent,
  MainContainer,
  Title,
  TextDiv,
  CreateText,
  HeaderWrapper,
  Form,
  LoginField,
  StyledMailIcon,
  Input,
  Wrapper,
  SubmitButton,
  BounceDiv,
} from "./ForgotPasswordPage.styles";

import Loader from "../../../components/Loader/Loader";
import Header from "../../../components/Header/Header";
import Footer from "../../../components/Footer/Footer";

import { ReactComponent as Loading } from "../../../assets/icons/loader-white.svg";

import { isValidEmail } from "../../../utils/utils";
import openToast from "../../../utils/toast";

import {
  selectSendingResetPending,
  setEmailInput,
} from "../../../store/slices/auth/slice";

import { sendCodeForNewPassword } from "../../../store/slices/auth/asyncThunks";
import { selectedLocale } from "../../../store/slices/common/slice";

const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toastId = useRef(null);

  const [checkValidation, setCheckValidation] = useState(false);
  const [email, setEmail] = useState("");

  const locale = useSelector(selectedLocale);
  const loading = useSelector(selectSendingResetPending);

  const ar = locale === "ar";

  const validateForm = () => {
    let formIsValid = true;

    if (!email) {
      openToast(toastId, "sign-up", "error", t("email-is-required"));
      formIsValid = false;
      return;
    } else if (!isValidEmail(email)) {
      openToast(toastId, "sign-up", "error", t("invalid-email-format"));

      formIsValid = false;
      return;
    }

    return formIsValid;
  };

  const handleSendEmailWithCode = () => {
    setCheckValidation(true);
    if (validateForm()) {
      dispatch(sendCodeForNewPassword(email))
        .unwrap()
        .then((response) => {
          openToast(
            toastId,
            "success-sendCode",
            "success",
            t("email-successfully-sent")
          );
          navigate("/set-up-new-password");
        })
        .catch((error) => {
          openToast(
            toastId,
            "forgot-password-email-send",
            "error",
            t(error.message)
          );
        });
    }
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSendEmailWithCode();
    }
  };

  useEffect(() => {
    document.addEventListener("keypress", handleKeyPress);
    window.scrollTo(0, 0);

    return () => {
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <MainContainer>
      <HeaderWrapper>
        <Header />
      </HeaderWrapper>

      <BounceDiv>
        <ScreenContent>
          <Wrapper>
            <Title>{t("welcome-to-ygii")}</Title>

            <TextDiv>
              <CreateText>{t("dont-have-an-account")}</CreateText>
              <Link to="/sign-up" className="signup">
                {t("sign-up")}
              </Link>
            </TextDiv>
          </Wrapper>

          <Form>
            <LoginField>
              <StyledMailIcon $ar={ar} />
              <Input
                $ar={ar}
                $error={checkValidation && !email}
                type="text"
                placeholder={t("email-address")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </LoginField>
          </Form>
          {!loading ? (
            <ButtonContainer>
              <SubmitButton
                onClick={() => {
                  handleSendEmailWithCode();
                  dispatch(setEmailInput(email));
                }}
              >
                {t("set-up-new-password")}
              </SubmitButton>
            </ButtonContainer>
          ) : (
            <ButtonContainer>
              <SubmitButton disabled>
                <Loading height={30} />
              </SubmitButton>
            </ButtonContainer>
          )}
        </ScreenContent>
      </BounceDiv>
      {loading && <Loader />}
      <Footer ar={ar} />
    </MainContainer>
  );
};

export default ForgotPasswordPage;
